<div [class]="'scenario-item ' + (innerItemClass ?? '')">
  <div class="scenario-name">
    {{ scenario.instanceName || 'N/A' }} / {{ scenario.snapshotName || 'N/A' }} /
    {{ scenario.scenarioName }}
  </div>
  <button
    mat-icon-button
    color="primary"
    class="filter-button"
    onclick="this.blur()"
    *ngIf="!layerIsVisible"
    (click)="showLayer($event)"
  >
    <wlm-icon class="visibility-button" icon="visibility_off"></wlm-icon>
  </button>
  <button
    mat-icon-button
    color="primary"
    class="filter-button"
    onclick="this.blur()"
    *ngIf="layerIsVisible"
    (click)="hideLayer($event)"
  >
    <wlm-icon class="visibility-button" icon="visibility"></wlm-icon>
  </button>
</div>
